import { render, staticRenderFns } from "./AddResponseCode.vue?vue&type=template&id=2e971438&"
import script from "./AddResponseCode.vue?vue&type=script&lang=js&"
export * from "./AddResponseCode.vue?vue&type=script&lang=js&"
import style0 from "./AddResponseCode.vue?vue&type=style&index=0&id=2e971438&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports